import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import css from '../../node_modules/@styled-system/css/dist/index.esm.js';
import '../typography/Text.js';
import '../typography/Display.js';
import '../typography/Heading.js';
import '../typography/Label.js';
import { Paragraph } from '../typography/Paragraph.js';
import { AnimatePresence } from 'framer-motion';
import React__default from 'react';
import styled from 'styled-components';
import { Input } from './Input.js';
import { InputLeftElement } from './InputElement.js';
import { InputGroup } from './InputGroup.js';
var PrefixContainer = styled(Paragraph)(css({
  color: "grey.1",
  height: "100%",
  boxSizing: "border-box"
}));
var MobileInput = React__default.forwardRef(function (_a, ref) {
  var onFocus = _a.onFocus,
    onBlur = _a.onBlur,
    onChange = _a.onChange,
    prefix = _a.prefix,
    rest = __rest(_a, ["onFocus", "onBlur", "onChange", "prefix"]);
  var _b = React__default.useState(false),
    isFocused = _b[0],
    setIsFocused = _b[1];
  var _c = React__default.useState(undefined),
    currentValue = _c[0],
    setCurrentValue = _c[1];
  var hasValue = ((currentValue === null || currentValue === void 0 ? void 0 : currentValue.length) || 0) > 0;
  var handleChange = function handleChange(e) {
    setCurrentValue(e.target.value);
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  };
  var handleFocus = function handleFocus(e) {
    setIsFocused(true);
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
  };
  var handleBlur = function handleBlur(e) {
    setIsFocused(false);
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
  };
  return React__default.createElement(InputGroup, null, React__default.createElement(AnimatePresence, null, (hasValue || isFocused) && React__default.createElement(InputLeftElement, {
    height: "19px !important",
    top: "initial !important",
    bottom: "9px !important",
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: 0.2,
      ease: "easeOut"
    }
  }, React__default.createElement(PrefixContainer, null, prefix))), React__default.createElement(Input, __assign({
    type: "text",
    pl: "".concat(9.61 * prefix.length + 4.8, "px")
  }, rest, {
    ref: ref,
    onChange: handleChange,
    onFocus: handleFocus,
    onBlur: handleBlur
  })));
});
export { MobileInput };